import React from 'react';
import { NavLinkProps } from 'react-router-dom';

import { VaultNavigationItem } from 'vault/components/VaultNavigationItem';

const isEditionsActive: NavLinkProps['isActive'] = (_match, location) => {
  const exactMatcher = new RegExp(`${Routes.vault_path()}$`);
  return exactMatcher.test(location.pathname);
};

export const VaultNavigation = () => {
  return (
    <div className='pt-2 pt-sm-2'>
      <h1 className='vault-navigation__headline headline headline--medium mb-2'>Your Vault</h1>
      <div className='mb-0 mb-sm-1 pb-mini'>
        <VaultNavigationItem
          to={Routes.vault_path()}
          title='Editions'
          isActive={isEditionsActive}
        />
        <VaultNavigationItem to={Routes.vault_playlists_path()} title='Playlists' />
      </div>
    </div>
  );
};
